<template>
  <div class="flex flex-col min-h-screen">
    <CommonHeader />
    <main class="flex-1 flex flex-col items-center w-full">
      <slot></slot>
    </main>
    <CommonFooter />
  </div>
</template>

<script>
import Header from "@/components/common/header/CommonHeader";
import Footer from "@/components/common/footer/CommonFooter";
export default {
  name: "CommonLayout",
  components: { CommonHeader: Header, CommonFooter: Footer }
}
</script>
